//Get Reducer Call--->
export const getAreaRequest = (page: number, size: number, search: string) => ({
    type: 'GET_AREA_TYPE_REQUEST',
    payload: { page, size, search },
});

export const getAreaSuccess = (data: any) => ({
    type: 'GET_AREA_TYPE_SUCCESS',
    payload: { data },
});

export const getAreaFailure = (data: string) => ({
    type: 'GET_AREA_TYPE_FAILURE',
    payload: { data },
});

export const resetGetArea = () => ({
    type: 'RESET_GET_AREA_TYPE',
});

//Create Reducer Call--->
export const createAreaRequest = (data: any) => ({
    type: 'CREATE_AREA_TYPE_REQUEST',
    payload: data,
});

export const createAreaSuccess = (data: any) => ({
    type: 'CREATE_AREA_TYPE_SUCCESS',
    payload: { data },
});

export const createAreaFailure = (data: string) => ({
    type: 'CREATE_AREA_TYPE_FAILURE',
    payload: { data },
});

export const resetCreateArea = () => ({
    type: 'RESET_CREATE_AREA_TYPE',
});

//Update Reducer Call--->
export const updateAreaRequest = (data: any, id: string) => ({
    type: 'UPDATE_AREA_TYPE_REQUEST',
    payload: { data, id },
});

export const updateAreaSuccess = (data: any) => ({
    type: 'UPDATE_AREA_TYPE_SUCCESS',
    payload: { data },
});

export const updateAreaFailure = (data: string) => ({
    type: 'UPDATE_AREA_TYPE_FAILURE',
    payload: { data },
});

export const resetUpdateArea = () => ({
    type: 'RESET_UPDATE_AREA_TYPE',
});
//Delete Reducer Call--->
export const deleteAreaRequest = (id: string) => ({
    type: 'DELETE_AREA_TYPE_REQUEST',
    payload: { id },
});

export const deleteAreaSuccess = (data: any) => ({
    type: 'DELETE_AREA_TYPE_SUCCESS',
    payload: { data },
});

export const deleteAreaFailure = (data: string) => ({
    type: 'DELETE_AREA_TYPE_FAILURE',
    payload: { data },
});

export const resetDeleteArea = () => ({
    type: 'RESET_DELETE_AREA_TYPE',
});
